import {
  getDocumentaryMails,
  getGetDocumentaryMailsQueryKey
} from 'client/api/backend/documentary-mails/documentary-mails';
import { GetDocumentaryMailsParams } from 'client/api/backend/schemas';
import { ErrorType } from 'client/core/network/mutators/apiClient';
import {
  QueryFunction,
  QueryKey,
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from 'react-query';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AsyncReturnType<T extends (...args: any) => Promise<any>> = T extends (
  ...args: any
) => Promise<infer R>
  ? R
  : any;

export const InfiniteMailsPageStart = 0;

export const useInfiniteMails = <
  TData = AsyncReturnType<typeof getDocumentaryMails>,
  TError = ErrorType<void>
>(
  params?: GetDocumentaryMailsParams,
  options?: {
    query?: UseInfiniteQueryOptions<
      AsyncReturnType<typeof getDocumentaryMails>,
      TError,
      TData
    >;
  }
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const { query: queryOptions } = options || {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDocumentaryMailsQueryKey(params);

  const queryFn: QueryFunction<
    AsyncReturnType<typeof getDocumentaryMails>
  > = ctx =>
    getDocumentaryMails({
      ...params!,
      pageNumber: ctx.pageParam ?? InfiniteMailsPageStart
    });

  const query = useInfiniteQuery<
    AsyncReturnType<typeof getDocumentaryMails>,
    TError,
    TData
  >(queryKey, queryFn, queryOptions);

  return {
    queryKey,
    ...query
  };
};
